export const SEED_TO_SALE_ROUTE_NAMES = {
  SEED_TO_SALE: 'seed-to-sale',
  SEED_TO_SALE_PACKAGES: 'seed-to-sale-packages',
  SEED_TO_SALE_BUYER_PACKAGES: 'seed-to-sale-buyer-packages',
  SEED_TO_SALE_PRODUCTS: 'seed-to-sale-products',
  SEED_TO_SALE_PRODUCTS_EDIT_MAPPING: 'seed-to-sale-products-edit-mapping',
  SEED_TO_SALE_WILDCARD: 'seed-to-sale-wildcard',
  SEED_TO_SALE_REFRESH_REQUESTS: 'seed-to-sale-refresh-requests',
  SEED_TO_SALE_TRANSFERS: 'seed-to-sale-transfers',
  SEED_TO_SALE_TEMPLATES: 'seed-to-sale-templates',
  SEED_TO_SALE_TEMPLATES_NEW: 'seed-to-sale-templates-new',
  SEED_TO_SALE_TEMPLATES_EDIT: 'seed-to-sale-templates-edit',
};
